export default __webpack_public_path__ + "static/media/Search-Glass.2be2f10d.svg";